/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: wuzuojie 15727841808@163.com
 * @LastEditTime: 2023-08-05 17:11:16
 */
const order = [
	{
		path: '/order',
		component: null,
		name: '订单',
		id: 5,
		parentId: 0,
		keepAlive: false,
		showBread: false,
		visible: true,
		useTemplate: false,
		redirect: '/order/list',
		children: [
			{
				path: 'list',
				component: 'shopManage/orderDetails/list',
				name: '订单管理',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: true,
				useTemplate: false,
			},
			{
				path: 'record',
				component: 'shopManage/orderDetails/record',
				name: '导出记录',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: false,
				useTemplate: false,
			},
			{
				path: 'updateLog',
				component: 'shopManage/orderDetails/updateLog',
				name: '导出记录',
				parentId: 5,
				keepAlive: false,
				showBread: false,
				visible: false,
				useTemplate: false,
			},
		],
	},
];
export default order;
